import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import EmployerRegisterForm from '$components/RegisterForm/EmployerRegisterForm';
import { useAppSelector } from '$hooks/use-app-selector.hook';
import RemoteSVG from '$components/RemoteSVG/RemoteSVG';

const EmployerRegisterScreen = () => {
  const [t] = useTranslation('global');
  const { logoUrl, displayName } = useAppSelector((state) => state.brand);
  const [searchParams] = useSearchParams();
  const isMktVariant = searchParams.get('mkt') === '1';
  const mktRedirectUrl = `${import.meta.env.REACT_APP_SPK_URL}/search?query=Executive+Assistant`;
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-employer-background font-mulish text-spk-highContrast pt-24 pb-2 gap-9">
      <div className="flex flex-col gap-9">
        <div className="flex gap-28 justify-center">
          <div className="w-1/3 flex flex-col gap-4 relative">
            <div className="flex flex-row gap-3 justify-center self-start absolute -top-12">
              {logoUrl && (
                <RemoteSVG svgProps={{ className: 'w-24' }} url={logoUrl} />
              )}
              <div className="flex items-center justify-center w-fit bg-spk-highContrast rounded-md px-1.5">
                <p className="text-sm font-bold text-spk-softBlue110">
                  {t('register.employerTag')}
                </p>
              </div>
            </div>
            <h1 className="text-5xl font-black m-0">
              {isMktVariant
                ? t('register.employerTitleMkt')
                : t('register.employerTitle', { brandName: displayName })}
            </h1>
            <p className="text-spk-mediumContrast">
              {t('register.alreadyHave')}&nbsp;
              <Link
                to={`/client_login${
                  searchParams.get('shareCandidatesIds')
                    ? `?shareCandidatesIds=${searchParams.get(
                        'shareCandidatesIds'
                      )}`
                    : ''
                }`}
                className="text-employer-primary font-bold underline"
              >
                {t('register.logIn')}
              </Link>
            </p>
          </div>
          <div className="">
            <EmployerRegisterForm
              successRedirectUrl={isMktVariant ? mktRedirectUrl : undefined}
            />
          </div>
        </div>
      </div>
      <div className="">
        <p className="text-spk-mediumContrast">
          {t('register.areYouCandidate')}&nbsp;
          <Link to="/login" className="text-employer-primary font-bold">
            {t('register.startHere')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default EmployerRegisterScreen;
